import React from 'react';
import styled from '@emotion/styled';
import range from 'lodash/range';
import { ComponentTextMedium, ComponentTextSmall } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';

export function NumbersRowInput({
    value,
    onValueChange,
    minLabel,
    maxLabel,
    range: inputRange,
}: {
    value: number | undefined | null;
    onValueChange: (value: number) => void;
    minLabel: string;
    maxLabel: string;
    range: [number, number];
}) {
    const [minRange, maxRange] = inputRange;

    return (
        <div>
            <RatingList>
                {range(minRange, maxRange + 1).map(i => (
                    <RatingElement key={i} onClick={() => onValueChange(i)} active={value === i}>
                        <RatingElementText bold active={value === i}>
                            {i}
                        </RatingElementText>
                    </RatingElement>
                ))}
            </RatingList>
            <LabelsWrapper>
                <ComponentTextSmall fontColor="gray55" bold>
                    {minLabel}
                </ComponentTextSmall>
                <ComponentTextSmall fontColor="gray55" bold>
                    {maxLabel}
                </ComponentTextSmall>
            </LabelsWrapper>
        </div>
    );
}

const RatingList = styled.ul({
    display: 'flex',
    padding: 0,
    marginBottom: 26,
});

const RatingElement = styled.li<{ active: boolean }>(props => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 6.5px',
    width: 62,
    height: 62,
    borderRadius: 31,
    border: `1.8px solid ${colors.gray05}`,
    boxShadow: '0px 5.2px 15.6px rgba(218, 225, 234, 0.5)',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    backgroundColor: props.active ? colors.blue55 : colors.white,
}));

const RatingElementText = styled(ComponentTextMedium)<{ active: boolean }>(props => ({
    color: props.active ? colors.white : colors.blue75,
    transition: 'color 0.3s',
    userSelect: 'none',
}));

const LabelsWrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 6.5px',
    marginBottom: 40,
});
